var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartedRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0639 4.66383L6.38388 0.999828C6.31987 0.935828 6.28787 0.861161 6.28787 0.775828C6.28787 0.679828 6.31987 0.599828 6.38388 0.535828C6.44788 0.461161 6.52254 0.423828 6.60788 0.423828C6.70388 0.423828 6.78388 0.455828 6.84788 0.519828L11.3279 4.99983L6.84788 9.47983C6.78388 9.54383 6.70388 9.57583 6.60788 9.57583C6.52254 9.57583 6.44788 9.54383 6.38388 9.47983C6.31987 9.41583 6.28787 9.34116 6.28787 9.25583C6.28787 9.15983 6.31987 9.07983 6.38388 9.01583L10.0639 5.33583H1.00787C0.911875 5.33583 0.831875 5.30383 0.767875 5.23983C0.703875 5.17583 0.671875 5.10116 0.671875 5.01583C0.671875 4.91983 0.703875 4.83983 0.767875 4.77583C0.831875 4.70116 0.911875 4.66383 1.00787 4.66383H10.0639Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartedRightIcon);
export default __webpack_public_path__ + "static/media/started-right-icon.2e0c2dd236204139298c481cb0b04b1a.svg";
export { ForwardRef as ReactComponent };